export enum SHIPPING_PLAN_STATUS {
  PENDING = "PENDING",
  SHIPMENTS_CREATED = "SHIPMENTS_CREATED",
}
